import React from "react";

export function InsertLineBreaks({
  content,
}: {
  content: React.ReactNode[];
}): React.ReactNode[] {
  const result: React.ReactNode[] = [];

  content.forEach((node, i) => {
    if (typeof node === "string") {
      const parts = node.split("\n");
      parts.forEach((part, j) => {
        result.push(part);
        if (j < parts.length - 1) {
          result.push(<br key={`br-${i}-${j}`} />);
        }
      });
    } else if (Array.isArray(node)) {
      result.push(...InsertLineBreaks({ content: node as React.ReactNode[] }));
    } else {
      result.push(node);
    }
  });

  return result;
}
